module.exports = __webpack_public_path__ + "img/absorbente8.39dc4499.jpg";